import { execOnLoad } from '@general/helpers';
import './subcategories.scss';
import Swiper from 'swiper';
import { Navigation, FreeMode } from 'swiper/modules';
import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/pagination';

if (!window.dAgency) window.dAgency = {};
window.dAgency.initSubcategories = (context) => {
  const sectionContainer = context.classList.contains('shopify-section')
    ? context
    : context.closest('.shopify-section');
  if (!sectionContainer) return;

  const slider = sectionContainer.querySelector('.subcategories__slider');
  if (!slider) return;

  new Swiper(slider, {
    loop: false,
    modules: [Navigation, FreeMode],
    navigation: {
      prevEl: sectionContainer.querySelector('.subcategories__arrow--left'),
      nextEl: sectionContainer.querySelector('.subcategories__arrow--right'),
    },
    freeMode: {
      enabled: true,
    },
    slidesPerView: 'auto',
  });
};

execOnLoad(window.dAgency.initSubcategories, '.subcategories__section');
